// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2vghN","col":"styles_col__1LiWv"};